import { ASIconButton, ComponentSize, PodiumIcon } from '@eleventheye/asui';
// import ASButton from 'components/asbutton/ASButton';
import React from 'react';

type StandingsButtonProps = {
  className?: string;
  onShowStandings?: () => void;
  selected?: boolean;
} & Pick<React.HTMLProps<HTMLDivElement>, 'style'>;

const StandingsButton: React.FC<StandingsButtonProps> = ({
  className = '',
  onShowStandings = () => undefined,
  selected = false,
  ...props
}) => {
  return (
    <ASIconButton
      className={className}
      selected={selected}
      toggle
      style={{ ...props.style }}
      size={ComponentSize.Medium}
      iconSize={22}
      icon={PodiumIcon}
      onTapped={onShowStandings}
      title="SHOW DIVISION"
      aria-selected={selected}
    />
  );
};

export default StandingsButton;
